import React from 'react'

import { Skeleton } from '@mui/material'
import { useCustomerWorkflows } from 'features/customers/hooks/useCustomerWorkflows'

import { DescriptionListTable } from 'components/table'

const getWorkflowStatistics = (workflows: { status: string }[] = []) => {
  const total = workflows.length

  const stats = workflows.reduce<Record<string, number>>(
    (acc, workflow) => {
      acc[workflow.status] += 1
      return acc
    },
    { stopped: 0, active: 0, paused: 0 },
  )

  return { total, ...stats }
}

const CustomerMetricsWorkflows = () => {
  const { data, isLoading } = useCustomerWorkflows()

  const stats = getWorkflowStatistics(data?.workflows)

  const config = [
    { title: 'Connectors Total', field: 'total' },
    { title: 'Connectors Active', field: 'active' },
    { title: 'Connectors Paused', field: 'paused' },
    { title: 'Connectors Stopped', field: 'stopped' },
  ].map(item => ({ ...item, render: isLoading ? () => <Skeleton height={14} width={100} /> : undefined }))

  return <DescriptionListTable config={config} data={stats} titleCellStyle={{ width: 200 }} />
}

export default CustomerMetricsWorkflows
